<template>
	<Collapsible
		v-if="crossSell.length"
		class="sidebar-cart__crosssell"
		:initial-open="true"
	>
		<template slot="trigger">
			<h3 class="sidebar-cart__crosssell-title">
				<span
					class="sidebar-cart__crosssell-title-text"
					v-html="$t('cart.crossSell.title')"
				/>
				<span
					class="sidebar-cart__crosssell-title-count"
					v-html="crossSell.length"
				/>
			</h3>
		</template>

		<ul class="sidebar-cart__crosssell-items">
			<li
				v-for="product in crossSell"
				:key="product.code"
				class="sidebar-cart__crosssell-item"
			>
				<figure
					v-if="product.image"
					class="sidebar-cart__crosssell-item-image-wrapper"
				>
					<img
						class="sidebar-cart__crosssell-item-image-element"
						:src="product.image"
						:alt="product.name"
						loading="lazy"
					>
				</figure>

				<div
					class="sidebar-cart__crosssell-item-content"
					:class="{
						'sidebar-cart__crosssell-item-content--configurable': product.isConfigurable
					}"
				>
					<div
						class="sidebar-cart__crosssell-item-name"
						v-html="product.name"
					/>

					<Button
						v-if="product.isConfigurable"
						class="sidebar-cart__crosssell-item-configure-button"
						@click.prevent="onConfig(product)"
						level="outline"
						type="button"
						:text="$t('shoplist.product.configButton')"
						:disabled="lockedProducts[product.code]"
						tiny
					/>
					<button
						v-else
						class="sidebar-cart__crosssell-item-cart-button"
						@click="onCart(product)"
						:disabled="lockedProducts[product.code]"
					>
						<SVGBag/>
					</button>

					<div class="sidebar-cart__crosssell-item-price">
						<strike
							class="sidebar-cart__crosssell-item-price-old"
							v-if="originalPrice(product)"
							v-html="$options.filters.fwgpricecent(originalPrice(product), 'short')"
						/>
						<span
							class="sidebar-cart__crosssell-item-price-current"
							v-html="$options.filters.fwgpricecent(price(product), 'short')"
						/>
					</div>
				</div>
			</li>
		</ul>
	</Collapsible>
</template>

<script>
import Collapsible from '@/components/Collapsible'
import Button from '@/components/Button'

export default {
	components: {
		Collapsible,
		Button,
	},
	props: {
		crossSell: Array,
		lockedProducts: {
			type: Object,
			default() {
				return {}
			}
		}
	},
	methods: {
		price(product) {
			if (product.variants?.length) {
				return product.variants[0].price;
			}
			return product.price;
		},
		originalPrice(product) {
			let originalPrice = product.originalPrice;

			if (product.variants?.length) {
				originalPrice = product.variants[0].originalPrice;
			}
			return !!originalPrice && this.price(product) < originalPrice && originalPrice;
		},
		onConfig(product) {
			const item = {
				...product,
				price: this.price(product),
				variant: product.variants?.[0]?.name || product.name,
				selectedVariant: product.variants?.[0]?.code || product.code,
				isCrossSell: true,
			}

			this.$emit('config', item);
		},
		onCart(product) {
			this.addedToCart = false;

			const item = {
				quantity: 1,
				productCode: product.code,
				variantCode: product.variants?.[0]?.code || product.code,
				isCrossSell: true,
			}
			if (product.isEditable) {
				item.forceCopy = true
			}

			this.$emit('addToCart', item);
		},
	}
}
</script>

<style>

</style>
